import React from 'react';
import {
  TrendingDown,
  Shield,
  Database,
  CheckCircle,
  Zap,
  Users,
  Eye,
  AreaChart,
  Calculator,
  UserCheck,
  Plug,
  Package,
  Code2,
  ArrowLeftRight,
  Landmark,
} from 'lucide-react';

const Services: React.FC = () => {
  const solutions = [
    {
      icon: Code2,
      title: "SOFTWARE COMPANY",
      description: "End-to-end software development and engineering services, delivering scalable, high-quality solutions tailored to your business needs",
    },
    {
      icon: ArrowLeftRight,
      title: "DATA MIGRATION AND RECONCILIATION",
      description: "Seamless data migration and automated reconciliation services ensuring accuracy, integrity, and continuity across systems and platforms",
    },
    {
      icon: Landmark,
      title: "TAILOR MADE BANKING SOLUTION",
      description: "Custom-built banking solutions designed to fit your institution’s unique workflows, regulatory requirements, and operational objectives",
    },
    {
      icon: Users,
      title: "CRM",
      description: "Integrated customer relationship management tools to streamline client interactions, improve retention, and drive business growth",
    },
    {
      icon: AreaChart,
      title: "FUND REGULATORY REPORTING",
      description: "Fully digitalized, matrix-driven reporting ecosystem that automates end-to-end regulatory workflows",
    },
    {
      icon: Calculator,
      title: "FUND REGULATORY COMPUTATION",
      description: "The most advanced cloud-based calculation engine to deliver real-time, auditable results for all regulatory requirements",
    },
    {
      icon: Database,
      title: "FUND DATA MANAGEMENT",
      description: "Online platform that presents in an intuitive UI the fund data alongside the reportings, allowing for easy data management and validation",
    },
    {
      icon: UserCheck,
      title: "RISK MANAGEMENT CONSULTING",
      description: "Specialized experts consultants providing strategic guidance on all aspects of fund risk management, from regulatory compliance to operational efficiency",
    },
    {
      icon: Package,
      title: "MANAGED SERVICE",
      description: "End-to-end handling of compliance, data, and reporting workflows. Scalable, SLA-driven support for funds of all sizes.",
    },
    {
      icon: Plug,
      title: "API SERVICES",
      description: "Seamlessly plug Keops’ calculation modules into your existing systems via robust, developer-friendly APIs",
    }
  ];

  return (
    <section id="solutions" className="bg-white py-12 sm:py-16 lg:py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-black mb-4">
            Solutions
          </h2>
          {/* <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto text-gray-800">
            
          </p> */}
        </div>

        {/* Solution Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {solutions.map((solution, index) => {
            const IconComponent = solution.icon;
            return (
              <div 
                key={index}
                className="hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 p-6 lg:p-8"
              >
                {/* Icon */}
                <div className="flex items-center justify-center w-12 h-12 lg:w-14 lg:h-14 bg-blue-900 rounded-lg mb-4">
                  <IconComponent className="w-6 h-6 lg:w-7 lg:h-7 text-blue-200" />
                </div>

                {/* Title */}
                <h3 className="text-lg lg:text-xl font-semibold text-black mb-3">
                  {solution.title}
                </h3>

                {/* Description */}
                <p className="text-sm lg:text-base text-black mb-4 leading-relaxed">
                  {solution.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* ROI Highlight */}
        {/* <div className="mt-12 lg:mt-16">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl shadow-lg p-6 lg:p-8 text-white">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-center">
              <div>
                <h3 className="text-xl lg:text-2xl font-bold mb-4">
                  The KEOPS Advantage
                </h3>
                <p className="text-base lg:text-lg opacity-90 mb-6">
                  Future-proof your regulatory reporting while turning compliance costs 
                  into a competitive advantage. Experience measurable ROI from day one.
                </p>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="text-center">
                  <div className="text-2xl lg:text-3xl font-bold mb-2">80%</div>
                  <div className="text-sm lg:text-base opacity-90">Time Savings</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl lg:text-3xl font-bold mb-2">90%</div>
                  <div className="text-sm lg:text-base opacity-90">Error Reduction</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl lg:text-3xl font-bold mb-2">100%</div>
                  <div className="text-sm lg:text-base opacity-90">Faster Cycles</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl lg:text-3xl font-bold mb-2">100%</div>
                  <div className="text-sm lg:text-base opacity-90">Compliance</div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Services;
